import styled from "styled-components";
import { Link } from "react-router-dom";
import Badge from "../../../../components/flat/ui/Badge";
import InputOtp from "app/components/flat/ui/Inputs/InputOtp";

export const Header = styled.header`
  padding: 20px 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #e7e8ec;

  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Section = styled.section`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0 24px 24px;

  @media (max-width: 768px) {
    width: 100%;
    min-height: 100vh;
    padding: 20px;
  }
`;

export const Banner = styled.img`
  flex: 1;
  padding: 24px;
  max-width: 50%;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AuthPasswordPanel = styled.div`
  align-items: center;
  background-color: #f1f3f5;
  border-radius: 16px;
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 24px;
  max-width: 50%;
  min-height: calc(100vh - 120px);
  padding: 24px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PanelIllustration = styled.img`
  display: block;
  height: auto;
  max-height: min(392px, 60vh);
  max-width: min(446px, 100%);
  object-fit: contain;
  width: 100%;
`;

export const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Container = styled.div`
  max-width: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 20px;
    gap: 16px;
  }
`;

export const Title = styled.h1`
  color: var(--neutral-text-text-darker, #131313);
  font-family: var(--font-family-font-family-title, "Noto Sans");
  font-size: var(--font-size-font-size-20, 20px);
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const Subtitle = styled.p`
  color: var(--neutral-text-text-dark, #667085);
  text-align: center;
  font-family: var(--font-family-font-family-text, "Noto Sans");
  font-size: var(--font-size-font-size-14, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin: 0 0 16px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const SuccessMessage = styled.p`
  color: #01ab7d;
  font-family: var(--font-family-font-family-text, "Noto Sans");
  font-size: var(--font-size-font-size-14, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  margin: 0;
`;

export const ErrorMessage = styled.p`
  color: #e53935;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  margin: 8px 0 0;
  text-align: center;
  width: 100%;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e7e8ec;
  border-radius: 8px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 140%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #01ab7d;
  }
`;

export const ReadOnlyInput = styled(StyledInput)`
  background-color: #f8f9fa;
  color: #667085;
  cursor: default;

  &:focus {
    border-color: #e7e8ec;
  }
`;

export const AuthPasswordInput = styled(StyledInput)<{ $hasError?: boolean }>`
  border-color: ${({ $hasError }) => ($hasError ? "#e53935" : "#e7e8ec")};
`;

export const LinkButton = styled.button.attrs({ type: "button" })`
  background: none;
  border: none;
  color: #01ab7d;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  padding: 0;

  &:hover {
    color: #007656;
  }
`;

export const StyledLink = styled(Link)`
  color: #01ab7d;
  text-decoration: underline;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;

  &:hover {
    color: #007656;
  }
`;

export const FormField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldLabel = styled.label`
  color: #131313;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
`;

export const StyledBadge = styled(Badge)`
  cursor: default;
`;

export const StyledInputOtp = styled(InputOtp)``;

export const ButtonText = styled.span`
  color: #fff;
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Noto Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  gap: 10px;
`;

export const Span = styled.span`
  color: var(--neutral-text-text-dark, #383839);
  font-family: var(--font-family-font-family-text, "Noto Sans");
  font-size: var(--font-size-font-size-14, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  padding-top: 24px;
`;

export const ResendLink = styled.a<{ isDisabled?: boolean }>`
  color: ${({ isDisabled }) => (isDisabled ? "#a0a0a0" : "#01ab7d")} !important;
  text-decoration: underline !important;
  cursor: ${({ isDisabled }) =>
    isDisabled ? "not-allowed" : "pointer"} !important;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ isDisabled }) =>
      isDisabled ? "#a0a0a0" : "#007656"} !important;
    text-decoration: underline !important;
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
